// ============================================================
// Mora - Centralized Brand Constants
// ============================================================

export const BRAND = {
  name: 'Mora',
  tagline: 'A PREMIUM STANDARD OF SOPARI.',
  description: 'Premium Quality Supari crafted with simplicity, quality and the warmth of Indian snacking traditions.',
  whatsapp: '918780889867',
  phone: '+918780889867',
  phoneDisplay: '+91 87808 89867',
  email: 'info@moraenterprise.com',
  address: 'Shop no 16,Sahajananda heights, Yogichowk, To, Simada Rd, nr. Tirupati Society, Surat, Gujarat 395010',
  mapsUrl: 'https://share.google/MCu2clYdP9jCnUG58',
  website: 'https://moraenterprise.com',
};

export const NAVIGATION = [
  { label: 'Home', href: '/' },
  { label: 'Product', href: '/product' },
  { label: 'Why Mora', href: '/why-mora' },
  { label: 'Our Story', href: '/story' },
  { label: 'Contact', href: '/contact' },
];

export const SOCIAL_LINKS = [
  { label: 'Instagram', href: 'https://www.instagram.com/mora_enterprise', icon: 'Instagram' },
  { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61595631171059', icon: 'Facebook' },
  { label: 'YouTube', href: 'https://www.youtube.com/@MORAENTERPRISE', icon: 'Youtube' },
  // { label: 'Threads', href: 'https://www.threads.com/@Mora.in', icon: 'AtSign' },
  { label: 'Email', href: 'mailto:info@moraenterprise.com', icon: 'Mail' },
];

export const PRODUCT = {
  name: 'Mora Premium Sopari - Bengaluru',
  tagline: 'Premium Sopari. Distinctive Identity.',
  description: 'Premium Bengaluru Sopari from MORA ENTERPRISE, carefully selected with a focus on quality, traditional taste, and consistent presentation.',
  weight: '200 gm / 400 gm',
  taste: 'Traditional • Distinctive • Authentic',
  bestFor: 'Retail Stores • Wholesale Buyers • Distributors • Paan Shops',
  packaging: 'Premium packaging designed to protect product quality and maintain freshness.',
  price: 0,
  ingredients: 'Sopari (Areca Nut).',
  fssai: 'ADD_VALID_FSSAI_NUMBER',
  shelfLife: 'Refer to the product packaging for the best-before date.',
};

export const PRICING_TIERS = [
  {
    id: '1-packet',
    packets: 1,
    quantityLabel: '1 Packet',
    title: '1 Packet (500g)',
    weight: '500g',
    weightLabel: '500g',
    weightInGrams: 500,
    normalPrice: 249,
    finalPrice: 249,
    saving: 0,
    badge: null,
    popular: false,
    description: '1 Vacuum sealed 500g pouch of Mora KHARISING.',
  },
  {
    id: '2-packets',
    packets: 2,
    quantityLabel: '2 Packets',
    title: '2 Packets (1kg)',
    weight: '1kg',
    weightLabel: '1kg (2 x 500g)',
    weightInGrams: 1000,
    normalPrice: 499,
    finalPrice: 399,
    saving: 100,
    badge: 'Popular',
    popular: true,
    description: '2 Vacuum sealed 500g pouches. Ideal for daily tea-time & office cravings.',
  },
  {
    id: '3-packets',
    packets: 3,
    quantityLabel: '3 Packets',
    title: '3 Packets (1.5kg)',
    weight: '1.5kg',
    weightLabel: '1.5kg (3 x 500g)',
    weightInGrams: 1500,
    normalPrice: 749,
    finalPrice: 599,
    saving: 150,
    badge: 'Save ₹150',
    popular: false,
    description: '3 Vacuum sealed 500g pouches. Great for family snacking and pantry stock.',
  },
  {
    id: '4-packets',
    packets: 4,
    quantityLabel: '4 Packets',
    title: '4 Packets (2kg)',
    weight: '2kg',
    weightLabel: '2kg (4 x 500g)',
    weightInGrams: 2000,
    normalPrice: 999,
    finalPrice: 799,
    saving: 200,
    badge: 'Save ₹200',
    popular: false,
    description: '4 Pouches (2kg). Perfect balance of freshness and value.',
  },
  {
    id: '5-packets',
    packets: 5,
    quantityLabel: '5 Packets',
    title: '5 Packets (2.5kg)',
    weight: '2.5kg',
    weightLabel: '2.5kg (5 x 500g)',
    weightInGrams: 2500,
    normalPrice: 1249,
    finalPrice: 999,
    saving: 250,
    badge: 'Best Value',
    popular: false,
    description: '5 Pouches (2.5kg). Best value pack for everyday peanut lovers.',
  },
  {
    id: '10-packets',
    packets: 10,
    quantityLabel: '10 Packets',
    title: '10 Packets (5kg)',
    weight: '5kg',
    weightLabel: '5kg Box (10 x 500g)',
    weightInGrams: 5000,
    normalPrice: 2499,
    finalPrice: 1999,
    saving: 500,
    badge: 'Mega Saver',
    popular: false,
    description: '10 Pouches (5kg) master carton. Best for events, gifting & bulk use.',
  },
];

export const PRODUCT_HIGHLIGHTS = [
  {
    title: 'Premium Sopari',
    description: 'Carefully selected Bengaluru Sopari with a focus on quality and consistency.',
    icon: 'Award',
  },
  {
    title: 'Expertly Cut',
    description: 'Carefully cut sopari pieces for a consistent size and premium presentation.',
    icon: 'Scissors',
  },
  {
    title: 'Traditional Choice',
    description: 'Inspired by India’s rich sopari tradition and distinctive product character.',
    icon: 'Leaf',
  },
  {
    title: 'Quality Packaging',
    description: 'Premium packaging designed to help protect product quality and freshness.',
    icon: 'PackageCheck',
  },
];

export const PRODUCT_BADGES = [
  'Premium Sopari',
  'Bengaluru Sopari',
  'Carefully Selected',
  'Quality Focused',
  'Traditional Product',
  'Premium Packaging',
];

export const WHY_BENEFITS = [
  {
    title: 'Careful Selection',
    description: 'Bengaluru Sopari selected with attention to product quality and consistency.',
    icon: 'Heart',
  },
  {
    title: 'Distinctive Identity',
    description: 'MORA ENTERPRISE brings a distinctive brand identity to premium sopari.',
    icon: 'Zap',
  },
  {
    title: 'Traditional Heritage',
    description: 'Inspired by India’s long-standing sopari traditions.',
    icon: 'Leaf',
  },
  {
    title: 'Quality Packaging',
    description: 'Thoughtfully packaged to help protect product quality.',
    icon: 'Sun',
  },
  {
    title: 'Premium Presentation',
    description: 'A distinctive presentation for retail and wholesale customers.',
    icon: 'Sparkles',
  },
];

export const BENEFITS_FULL = [
  {
    title: 'Premium Bengaluru Sopari',
    description: 'Selected with a focus on product quality and consistency.',
    icon: 'Award',
  },
  {
    title: 'Careful Processing',
    description: 'Prepared and presented with attention to product standards.',
    icon: 'Flame',
  },
  {
    title: 'Distinctive Product',
    description: 'A traditional sopari product under the MORA ENTERPRISE brand.',
    icon: 'Dumbbell',
  },
  {
    title: 'Retail & Wholesale',
    description: 'Enquiries welcome from retailers, wholesalers, and distributors.',
    icon: 'Coffee',
  },
  {
    title: 'Indian Tradition',
    description: 'Inspired by India’s established sopari culture.',
    icon: 'MapPin',
  },
  {
    title: 'Premium Packaging',
    description: 'Packaging designed to protect the product and support its presentation.',
    icon: 'PackageCheck',
  },
];

export const FOUNDERS = [
  {
    name: 'Sahil',
    role: 'Founder & CEO',
    description: 'Leading brand vision, business strategy, brand building, and market expansion.',
  },
  {
    name: 'Hemang',
    role: 'Co-Founder & Managing Director',
    description: 'Leading operations, financial planning, execution, and business administration.',
  },
];

export const STORY_TIMELINE = [
  {
    label: 'THE BEGINNING',
    title: 'Two Brothers, One Vision',
    description: 'MORA ENTERPRISE began with Sahil and Hemang, united by a vision to build a distinctive sopari brand.',
  },
  {
    label: 'THE INSPIRATION',
    title: 'Inspired by Tradition',
    description: 'Inspired by India’s traditional sopari culture and the importance of quality in every product.',
  },
  {
    label: 'THE COMMITMENT',
    title: 'Quality & Care',
    description: 'We focus on product selection, consistent standards, and thoughtful packaging.',
  },
  {
    label: 'THE VISION',
    title: 'Growing the MORA Identity',
    description: 'Our vision is to build lasting business relationships and bring MORA ENTERPRISE to customers across India.',
  },
];

export const NUTRITION_DATA = [];